export const frontStyleEvhSelector = ({frontStyleEvh}) => frontStyleEvh